import React, { useState, useEffect } from "react";
import HeaderBar from "../../../../components/header/headerBar";
import EmptyModel from "../../../../components/modal/emptyModal";
import MainButton from "../../../../components/button/mainButton";
import { Table, TableColumn } from "../../../../components/table";
import axios from "axios";
import { useParams } from "react-router-dom";
import { getLocalUrl } from "../../../../functions";
import "../../../../assets/styles/components/numberFormat.scss";
import "../../../../assets/styles/admin/agencyListMember.scss";
import { getFileHostUrl } from "../../../../helpers/functions";
import CountryPhoneInput, {
  CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import {
  Form,
  Row,
  Col,
  Input,
  Modal,
  Space,
  Button,
  Pagination,
  Upload,
  message,
  Image,
  InputNumber,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
// import Modal from "antd/lib/modal/Modal";
import { Icon } from "@iconify/react";

const AgencyMember = () => {
  interface ParamTypes {
    id: string;
  }
  const { confirm } = Modal;
  let [formMember] = Form.useForm();
  const { id } = useParams<ParamTypes>();

  const [isOpen, setIsOpen] = useState(false);
  // $route.params.id
  const [membersId, setMembersId] = useState("");
  const [member, setMember] = useState<any>([]);

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [idCardPic, setIdCardPic] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [type, setType] = useState("");
  const [pages, setPages] = useState(1);
  const [countPages, setCountPages] = useState(1);
  const [idDatas, setIdDatas] = useState<any>("");

  const [fileList, setFileList] = useState<any>([]);

  const [value1, setValue1] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [valuePhone1, setPhoneValue1] = useState<any>({});

  const columns = [
    {
      title: "",
    },
    {
      title: "Code",
      align: "center",
    },
    {
      title: "Name - Surname",
    },
    {
      title: "Tel.",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 3,
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getData = () => {
    axios.get(`/agencies/members/?agencyId=${id}&page=${pages}`).then((res) => {
      console.log("res.data.data =>", res?.data?.data);
      setMember(res?.data?.data);
    });
  };

  const getDataOne = (id: any) => {
    console.log("id", id);

    axios.get(`/agencies/members/${id}`).then((res) => {
      setIdDatas(id);
      console.log("resssss", res?.data);
      setValue1(res?.data?.phoneNumbersFirst);
      checkValue1(res?.data?.phoneNumbersFirst);
      const imageUrl = getFileHostUrl(res?.data?.imageIdCard);
      formMember.setFieldsValue({
        code: res?.data?.code,
        idCard: res?.data?.idCard,
        name: res?.data?.name,
        file: res?.data?.imageIdCard,
        phoneNumber: res?.data?.phoneNumber,
      });
      setFileList([
        {
          uid: "1",
          name: res?.data?.imageIdCard,
          status: "done",
          url: imageUrl,
        },
      ]);
      console.log("imageUrl", imageUrl);

      // setIdCardPic(imageUrl);
      console.log("res?.data?.imageIdCard", res?.data?.imageIdCard);

      // let images = [];
      // for (let i = 0; i < res?.data?.imageIdCard; i++) {
      //   const newObj = {
      //     name: "image.png",
      //     status: "done",
      //     url: `${imageUrl}`,
      //   };
      //   images.push(newObj);
      // }

      // console.log("imges", images);

      // setFileDocReceive({ imageUrl, raw: null });

      // formMember.setFieldsValue({});

      // const { originFileObj } = e.file;

      // const url = getLocalUrl(originFileObj);
      // setFileDocReceive({ url, raw: originFileObj });
    });
  };

  const onchangePic = (e: any) => {
    // console.log("e change pic contact =>", e.file);
    const { originFileObj } = e.file;
    const url = getLocalUrl(originFileObj);
    setFileList([
      {
        uid: "1",
        name: e?.file?.name,
        url: url,
      },
    ]);
    // formAgencyList.setFieldsValue({ copyOfBankAccount: "" });
    // setContactFile([]);
  };
  const checkValue1 = (value: any) => {
    console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue1(body);
      }, 200);
    }
  };
  const creatData = async (values: any) => {
    console.log("value", values);
    // if (!fileDocReceive.raw) {
    //   message.warning("Please Upload IdCard Image!");
    //   return;
    // }
    // axios.post(`/agencies/members`, values).then((res) => {
    //   setTimeout(() => getData(), 200);
    //   setIsOpen(false);
    // });
    try {
      const xdata = await axios.post(`/agencies/members`, {
        agency: id,
        code: values?.code,
        idCard: values?.idCard,
        name: values?.name,
        phoneNumbersFirst: valuePhone1,
        // phoneNumber: values?.phoneNumber,
      });

      const _id = xdata?.data?._id;

      console.log("_id", _id);

      // if (fileDocReceive.raw) {
      //   console.log(" fileDocReceive...", fileDocReceive.raw);

      const fmData = new FormData();
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      // fmData.append("file", fileDocReceive.raw);
      fmData.append("file", values?.file?.fileList[0]?.originFileObj);

      await axios.patch(
        `/agencies/members/upload-file?uploadId=${_id}`,
        fmData,
        config
      );
      // }

      message.success("บันทึกสำเร็จ Update Success!");
      setFileList([]);
      formMember.resetFields();
      setIsOpen(false);
      getData();
    } catch (err) {
      console.log("error =>", err);
      message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!");

      //   setIsOpen(false);
    }
  };

  const updateData = async (values: any) => {
    console.log("id update", idDatas);
    console.log("values", values);
    // console.log(" fileDocReceive...", fileDocReceive);

    // if (!fileDocReceive) {
    //   message.warning("Please Upload IdCard Image!");
    //   return;
    // }
    try {
      axios.patch(`/agencies/members/update/${idDatas}`, {
        name: values?.name,
        code: values?.code,
        idCard: values?.idCard,
        agency: values?.id,
        phoneNumbersFirst: valuePhone1,

        // phoneNumber: values?.phoneNumber,
      });
      // if (fileDocReceive.raw) {
      if (values.file.file) {
        const fmData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
        };
        // fmData.append("file", fileDocReceive.raw);
        fmData.append("file", values?.file?.fileList[0]?.originFileObj);

        await axios.patch(
          `/agencies/members/upload-file?uploadId=${idDatas}`,
          fmData,
          config
        );
      }

      // }

      setTimeout(() => getData(), 200);
      setIsOpen(false);
      formMember.resetFields();
      // setFileDocReceive({
      //   url: null,
      //   raw: null,
      // });
    } catch (err) {
      console.log("error =>", err);
      message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!");
    }
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }

  const deleteData = (id: any) => {
    axios.delete(`/agencies/members/delete/${id}`).then((res) => {
      // console.log(res.data);
      setTimeout(() => getData(), 200);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const Onsubmit = (value: any) => {
    if (type === "CREATE") {
      creatData(value);
    } else if (type === "UPDATE") {
      updateData(value);
    }
  };
  const onchangePage = (pages: any) => {
    setPages(pages);
    getData();
  };
  const onchangeNumber = (number: any) => {
    const { value } = number.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      // this.props.onChange(value);
      console.log("numval", value);
    }
  };
  const onPreview = (file: any) => {
    // console.log("file", file);
    let url = "";
    if (file?.url !== "") {
      url = getLocalUrl(file?.url);
    } else {
      url = getFileHostUrl(file?.name);
    }
    // console.log("url", url);
    window.open(url, "_blank");
  };
  return (
    <div>
      <HeaderBar title="AGENCY / MEMBER LIST" btnBack={true} />
      <div style={{ padding: "0px 40px" }}>
        <Modal visible={isOpen} footer={null} onCancel={() => setIsOpen(false)}>
          <Form form={formMember} onFinish={Onsubmit} layout="vertical">
            <h4>{type} MEMBER</h4>
            <Row justify="center" className="modal-agencyListMember">
              <Col xs={18} sm={18} md={18} lg={18}>
                <Form.Item
                  label="Member Code"
                  name="code"
                  rules={[
                    {
                      required: true,
                      // message: "Please input your Member Code!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
                <Form.Item
                  label="ID Card"
                  name="idCard"
                  rules={[
                    {
                      required: true,
                      // message: "Please input your ID Card!"
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
                <Form.Item
                  label="Attach ID Card"
                  name="file"
                  rules={[
                    {
                      required: true,
                      // message: "Please Attach ID Card!"
                    },
                  ]}
                >
                  <Upload
                    // listType={type == "create" ? "text" : "picture-card"}
                    // showUploadList={false}
                    onPreview={onPreview}
                    maxCount={1}
                    fileList={fileList}
                    onChange={(e: any) => onchangePic(e)}
                    accept="image/*,.pdf"
                    customRequest={({ onSuccess }: any) => {
                      onSuccess();
                    }}
                    // onRemove={(e) => {
                    //   console.log("remove", e);
                    // }}
                    // fileList={[
                    //   {
                    //     uid: "1",
                    //     name: "image.png",
                    //     status: "done",
                    //     url: idCardPic,
                    //   },
                    // ]}
                  >
                    {/* <Icon icon="akar-icons:circle-plus" color="#5baea9" /> */}
                    {/* {idCardPic && <Image width={200} src={idCardPic} />} */}
                    {/* <Button icon={<UploadOutlined />}>Upload</Button> */}
                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                  </Upload>

                  {/* {fileDocReceive?.imageUrl && (
                    <Image
                      src={fileDocReceive?.imageUrl}
                      alt="avatar"
                      style={{ maxWidth: "100%", marginTop: 5 }}
                      height="300px"
                    />
                  )} */}
                  {/* <Upload listType="picture-card" disabled>
                    <Icon icon="akar-icons:circle-plus" color="#5baea9" />
                  </Upload> */}
                  {/* {idCardPic && <Image width={200} src={idCardPic} />} */}
                  {/* <Upload
                    showUploadList={false}
                    customRequest={({ onSuccess }: any) => {
                      onSuccess();
                    }}
                    // action={`${REACT_APP_BASE_URL}/uploads/action`}
                    listType="picture-card"
                    maxCount={1}
                    onChange={onUploadDocReceiveChange}
                    style={{ width: `100%` }}
                  > */}
                  {/* <Button icon={<UploadOutlined />} style={{ width: `100%` }}>
                      Attach File
                    </Button> */}
                  {/* </Upload>
                  {fileDocReceive?.url && (
                    <Image
                      src={fileDocReceive?.url}
                      alt="avatar"
                      style={{ maxWidth: "100%", marginTop: 5 }}
                    />
                  )} */}
                </Form.Item>
                <Form.Item
                  label="Name-Surname"
                  name="name"
                  rules={[
                    {
                      required: true,
                      // message: "Please input your Name-Surname!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
                <Form.Item
                  className="selected-countrycode-agency"
                  label="Tel."
                  name="phoneNumber"
                  rules={[
                    {
                      required: false,
                      // message: "Please input your phoneNumber!",
                    },
                  ]}
                >
                  <ConfigProvider locale={en}>
                    <CountryPhoneInput
                      type="number"
                      value={value1}
                      onChange={(v: any) => {
                        setValue1(v);
                        checkValue1(v);
                      }}
                    />
                  </ConfigProvider>
                  {/* <Input type="tel" /> */}
                  {/* <Input type="number" /> */}
                </Form.Item>
              </Col>
            </Row>
            <Row className="buttonmodal-agencyListMember">
              <Col>
                <Space>
                  <Button
                    onClick={() => {
                      setIsOpen(false);
                      formMember.resetFields();
                      setFileList([]);
                    }}
                    className="cancleButton-agencyListMember"
                  >
                    ยกเลิก/Cancel
                  </Button>
                  <Button
                    className="confirmButton-agencyListMember"
                    htmlType="submit"
                    onClick={() => {
                      // if (type === "update") {
                      //   update();
                      // }
                    }}
                  >
                    บันทึกข้อมูล/Submit
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
      <div style={{ padding: "0px 40px" }}>
        <Row className="button-Create">
          <Space>
            <MainButton
              title={"CREATE MEMBER"}
              onClick={() => {
                setIsOpen(true);
                setType("CREATE");
                formMember.resetFields();
                setFileList([]);
              }}
            >
              <Icon
                icon="ant-design:plus-outlined"
                width="24"
                height="24"
                vFlip={true}
                color="#FFF"
              />
            </MainButton>
          </Space>
        </Row>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {member.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="15%" align="center">
                  {item.code}
                </TableColumn>
                <TableColumn width="50%">{item.name}</TableColumn>
                <TableColumn width="10%" align="center">
                  {item?.phoneNumbersFirst?.phone
                    ? "+" +
                      item?.phoneNumbersFirst?.code +
                      item?.phoneNumbersFirst?.phone
                    : item.phoneNumber}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      getDataOne(item._id);
                      setIsOpen(true);
                      setType("UPDATE");
                      formMember.resetFields();
                    }}
                  >
                    <Icon
                      icon="el:pencil-alt"
                      width="24"
                      height="24"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      showDeleteConfirm(item._id, item.name);
                    }}
                  >
                    <Icon
                      icon="fa-solid:trash-alt"
                      width="24"
                      height="24"
                      color="#FF6760"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
          <Row justify="end" className="pagination-agency">
            <Pagination
              defaultCurrent={pages}
              total={countPages}
              onChange={(e: any) => {
                onchangePage(e);
              }}
            />
          </Row>
        </div>
      </div>
    </div>
  );
};
export default AgencyMember;
